import { WorkOrderModuleCategoriesSettings } from 'lane-shared/domains/workOrder';
import { TeamCoverageEntry } from './coverageHoursTeamUtils';
import { toProtoDayNames } from './coverageHoursRowFormat';
import { minutesOfDay } from './coverageHoursTimeUtils';
import { CreateCoverageHoursTeam } from './useCreateCoverageHours';
import { CoverageHoursIssueTypeOption } from './useCoverageHoursOptions';
import {
  resolveIssues,
  shouldCreateNoneWithAllIssueTypes,
} from './coverageHoursPanelUtils';

export type CoverageHoursSavePayload = {
  issues: string[];
  teams: CreateCoverageHoursTeam[];
  shouldAlsoCreateNone: boolean;
};

export function toCoverageHoursTeamInputs(
  savedTeams: TeamCoverageEntry[]
): CreateCoverageHoursTeam[] {
  return savedTeams.map(team => ({
    teamId: team.teamId,
    blocks: team.coverageBlocks.map(block => ({
      daysOfWeek: toProtoDayNames(block.daysOfWeek),
      startMinute: minutesOfDay(block.startTime),
      endMinute: minutesOfDay(block.endTime, block.startTime),
    })),
  }));
}

export function buildCoverageHoursSavePayload({
  issueTypeValue,
  selectedCategory,
  issueTypeOptions,
  savedTeams,
}: {
  issueTypeValue: string;
  selectedCategory: WorkOrderModuleCategoriesSettings | undefined;
  issueTypeOptions: CoverageHoursIssueTypeOption[];
  savedTeams: TeamCoverageEntry[];
}): CoverageHoursSavePayload {
  const issues = resolveIssues(
    issueTypeValue,
    selectedCategory,
    issueTypeOptions
  );

  const teams = toCoverageHoursTeamInputs(savedTeams);

  // An empty `issues` call already creates the category-level routing itself,
  // so a second, separate None call is only needed when `issues` is non-empty.
  const shouldAlsoCreateNone =
    issues.length > 0 &&
    shouldCreateNoneWithAllIssueTypes(
      issueTypeValue,
      selectedCategory,
      issueTypeOptions
    );

  return { issues, teams, shouldAlsoCreateNone };
}
